var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSingleAnswerWrongcomponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D50000",
  fillRule: "evenodd",
  d: "M10 .5C4.48.5 0 4.98 0 10.5s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m1.209 10L16 5.709 14.791 4.5 10 9.291 5.209 4.5 4 5.709 8.791 10.5 4 15.291 5.209 16.5 10 11.709l4.791 4.791L16 15.291z",
  clipRule: "evenodd"
})));
export default SvgSingleAnswerWrongcomponent;